import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction, ScreenType } from '@/types/analytics';

import type { AnalyticsSettings } from '@/types/analytics';

interface SendSearchAnalyticsParams {
  action: AiGenScreenAction;
  /** Normalized term the event is about; omitted only for open/close. */
  keyword?: string;
  settings?: AnalyticsSettings;
}

/**
 * Sends one of the `search_*` actions on `ai_gen_screen_action`.
 *
 * Always `screen_type: search` — not `getScreenType()`. Search is a layer over
 * whatever screen is underneath (and stays mounted while the preset feed is
 * up), so the screen the store reports is not the screen the user acted on.
 *
 * Shared by both surfaces: every event except open/close comes from `useSearch`,
 * so the mobile screen and the desktop dropdown report identically.
 */
const sendSearchAnalytics = ({
  action,
  keyword,
  settings,
}: SendSearchAnalyticsParams) => {
  const mergedSettings: AnalyticsSettings = {
    ...(keyword && { keyword }),
    ...settings,
  };
  const hasSettings = Object.keys(mergedSettings).length > 0;

  sendAiGenScreenActionAnalytics({
    action,
    screen_type: ScreenType.SEARCH,
    ...(hasSettings && { settings: mergedSettings }),
  });
};

export default sendSearchAnalytics;
